if (!customElements.get('product-set-form')) {
  customElements.define(
    'product-set-form',
    class ProductSetForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      onSubmitHandler(event) {
        event.preventDefault();

        if (
          this.submitButton &&
          this.submitButton.hasAttribute('aria-disabled') &&
          this.submitButton.getAttribute('aria-disabled') === 'true'
        )
          return;

        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', 'true');
          if (this.submitButton.classList.contains('loading')) {
            this.submitButton.classList.add('loading');
          }
          const spinner = this.submitButton.querySelector('.loading__spinner');
          if (spinner) {
            spinner.classList.remove('hidden');
          }
        }

        const formData = new FormData(this.form);

        if (this.cart) {
          try {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            if (typeof this.cart.setActiveElement === 'function') {
              this.cart.setActiveElement(document.activeElement);
            }
          } catch (err) {
            console.warn('Error getting sections to render:', err);
            formData.append('sections', 'cart-drawer,cart-icon-bubble');
            formData.append('sections_url', window.location.pathname);
          }
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error('Error:', response.description || response.message);
              window.location.href = window.routes.cart_url || '/cart';
              return;
            }

            if (!this.cart) {
              window.location.href = window.routes.cart_url || '/cart';
              return;
            }

            // Use the cart's built-in renderContents method if available
            if (typeof this.cart.renderContents === 'function') {
              try {
                this.cart.classList.remove('is-empty');
                const innerContainer = this.cart.querySelector('.drawer__inner');
                if (innerContainer) {
                  innerContainer.classList.remove('is-empty');
                }

                this.cart.renderContents(response);
              } catch (err) {
                console.warn('Error rendering cart contents:', err);
                this.fallbackCartUpdate(response);
              }
            } else {
              this.fallbackCartUpdate(response);
            }
          })
          .catch((error) => {
            console.error('Error:', error);
            window.location.href = window.routes.cart_url || '/cart';
          })
          .finally(() => {
            if (this.submitButton) {
              this.submitButton.removeAttribute('aria-disabled');
              if (this.submitButton.classList.contains('loading')) {
                this.submitButton.classList.remove('loading');
              }
              const spinner = this.submitButton.querySelector('.loading__spinner');
              if (spinner) {
                spinner.classList.add('hidden');
              }
            }
          });
      }

      fallbackCartUpdate(data) {
        try {
          // Manual approach for updating cart contents
          if (data.sections) {
            const cartContent = data.sections['cart-drawer'];
            const cartIconBubble = data.sections['cart-icon-bubble'];

            if (cartContent) {
              const cartDrawerElement = document.getElementById('CartDrawer');
              if (cartDrawerElement) {
                cartDrawerElement.innerHTML = cartContent;
              }
            }

            if (cartIconBubble) {
              const iconBubbleElement = document.getElementById('cart-icon-bubble');
              if (iconBubbleElement) {
                iconBubbleElement.innerHTML = cartIconBubble;
              }
            }
          }

          // Try to open the cart drawer
          if (typeof this.cart.open === 'function') {
            setTimeout(() => {
              try {
                this.cart.open();
              } catch (err) {
                console.warn('Error opening cart drawer:', err);
                this.manuallyOpenDrawer();
              }
            }, 100);
          } else {
            this.manuallyOpenDrawer();
          }
        } catch (err) {
          console.warn('Error in fallback cart update:', err);
          if (typeof this.cart.open === 'function') {
            this.cart.open();
          } else {
            window.location.reload();
          }
        }
      }

      manuallyOpenDrawer() {
        try {
          this.cart.classList.add('animate', 'active');
          document.body.classList.add('overflow-hidden');
        } catch (err) {
          console.warn('Error manually activating drawer:', err);
          window.location.reload();
        }
      }
    }
  );
}
